import { useTheme } from "@/theme/ThemeProvider";
import { Stack } from "expo-router";

export default function LocationsLayout() {
  const { theme } = useTheme();

  return (
    <Stack
      screenOptions={{
        headerShown: true,
        headerStyle: {
          backgroundColor: theme.color.bg,
        },
        headerTintColor: theme.color.text,
        contentStyle: {
          backgroundColor: theme.color.bg,
        },
      }}
    >
      <Stack.Screen
        name="index"
        options={{
          title: "Meine Pflegeorte",
          headerShown: false,
        }}
      />
      <Stack.Screen
        name="[id]"
        options={{
          title: "Pflegeort",
          headerBackTitle: "Einstellungen",
        }}
      />
    </Stack>
  );
}
